"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Those color were crafted by Thanos and Stef. For whatever question about those, you know who to ask.
// Source: https://www.figma.com/file/StMhwdcwyORYvBwNTgEx58/BestPrice-Colors?node-id=57%3A2
// This file is auto-generated when you commit new changed to the palette page in Figma (above) and "yarn sync-colors".
exports.default = {
    transparent: 'transparent',
    brand500: '#ec1639',
    brand600: '#d41433',
    white: '#ffffff',
    gray100: '#f7fafc',
    gray200: '#f5f7f8',
    gray300: '#f1f0f5',
    gray400: '#dbdbdb',
    gray500: '#c3c4c7',
    gray600: '#a1a1a1',
    gray700: '#666666',
    gray800: '#444444',
    gray850: '#26282c',
    gray900: '#1d1d1d',
    gray920: '#161616',
    black: '#000000',
    grayBlue100: '#edf1f2',
    grayBlue200: '#dde2e6',
    grayBlue300: '#bbc9cf',
    grayBlue400: '#9ea7b1',
    grayBlue500: '#758190',
    grayBlue700: '#546076',
    grayBlue800: '#363e44',
    grayBlue850: '#2c3035',
    grayBlue900: '#23272b',
    blue100: '#ebf1fc',
    blue200: '#ccddf7',
    blue500: '#4178d8',
    blue300: '#adc8f1',
    blue400: '#709fe7',
    blue600: '#2e6ac7',
    blue700: '#1d538c',
    blue800: '#173563',
    blue900: '#0f2342',
    orange100: '#fff8f3',
    orange200: '#ffeee1',
    orange300: '#ffe3ce',
    orange400: '#ffcfaa',
    orange500: '#ffba85',
    orange600: '#e6a778',
    orange700: '#997050',
    orange800: '#73543c',
    orange900: '#4d3828',
    red100: '#ffe3e3',
    red300: '#ffa8a8',
    red500: '#ff6b6b',
    red700: '#f03e3e',
    red900: '#c92a2a',
    green100: '#d3f9d8',
    green300: '#8ce99a',
    green500: '#51cf66',
    green700: '#37b24d',
    green900: '#2b8a3e',
    yellow100: '#fff3bf',
    yellow300: '#ffe066',
    yellow500: '#fcc419',
    yellow700: '#f59f00',
    yellow900: '#e67700',
};
